import React from 'react'
import { Datagrid, List, TextField, DateField, Filter, FunctionField } from 'ra-ui-materialui'
import { Divider, Tab, Tabs } from '@mui/material'
import { Fragment } from 'react'
import ColoredLeadPropertyStatusField from '../../components/ColoredLeadPropertyStatusField'

import { BooleanInput, RadioButtonGroupInput, TextInput } from 'react-admin'

class TabbedDatagrid extends React.Component {
  tabs = [
    { id: 'passed', name: 'Past' },
    { id: 'future', name: 'Future' },
  ]

  state = { all: [], passed: [], future: [] }

  static getDerivedStateFromProps(props, state) {
    if (props.ids !== state[props.filterValues.visitdate_flag]) {
      return { ...state, [props.filterValues.visitdate_flag]: props.ids }
    }
    return null
  }

  handleChange = (event, value) => {
    const { filterValues, setFilters } = this.props
    setFilters({ ...filterValues, visitdate_flag: value })
  }

  render() {
    const { filterValues, ...props } = this.props
    return (
      <Fragment>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.visitdate_flag}
          filterDefaultValues={{ visitdate_flag: 'passed' }}
          indicatorColor="primary"
          onChange={this.handleChange}
        >
          {this.tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.visitdate_flag === 'passed' && (
            <Datagrid {...props} rowClick={(id) => `/leadProperties/${id}/visits`} optimized>
              <TextField label="Property Id" source="propertyid" sortable={false} />
              <FunctionField
                label="Lead Status"
                source="leadstatus"
                sortable={false}
                render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
              />
              <TextField label="Runner" source="runnername" sortable={false} />
              <TextField label="Visit Outcome" source="visitoutcome" sortable={false} />
              <TextField label="Visit Comment" source="visitcomment" sortable={false} />
              <FunctionField
                label="Visit Status"
                source="visitstatus"
                sortable={false}
                render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
              />
              <DateField label="Visit date" source="visitdate" sortable={false} />
            </Datagrid>
          )}
          {filterValues.visitdate_flag === 'future' && (
            <Datagrid {...props} rowClick={(id) => `/leadProperties/${id}/visits`} optimized>
              <TextField label="Property Id" source="propertyid" sortable={false} />
              <FunctionField
                label="Lead Status"
                source="leadstatus"
                sortable={false}
                render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
              />
              <TextField label="Runner" source="runnername" sortable={false} />
              <TextField label="Visit Outcome" source="visitoutcome" sortable={false} />
              <TextField label="Visit Comment" source="visitcomment" sortable={false} />
              <FunctionField
                label="Visit Status"
                source="visitstatus"
                sortable={false}
                render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
              />
              <DateField label="Visit date" source="visitdate" sortable={false} />
            </Datagrid>
          )}
          {filterValues.visitdate_flag === 'all' && (
            <Datagrid {...props} rowClick={(id) => `/leadProperties/${id}/visits`} optimized>
              <TextField label="Property Id" source="propertyid" sortable={false} />
              <FunctionField
                label="Lead Status"
                source="leadstatus"
                sortable={false}
                render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
              />
              <TextField label="Runner" source="runnername" sortable={false} />
              <TextField label="Visit Outcome" source="visitoutcome" sortable={false} />
              <TextField label="Visit Comment" source="visitcomment" sortable={false} />
              <FunctionField
                label="Visit Status"
                source="visitstatus"
                sortable={false}
                render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
              />
              <DateField label="Visit date" source="visitdate" sortable={false} />
            </Datagrid>
          )}
        </div>
      </Fragment>
    )
  }
}

const ListLeadInspection = ({ ...props }) => {
  const LeadPropertyFilter = (props) => (
    <Filter {...props}>
      <BooleanInput label="active" source="active_flag" alwaysOn />
      <BooleanInput label="mine" source="mine" alwaysOn />
      <TextInput label="runner" alwaysOn source="runner" />
      <RadioButtonGroupInput
        allowEmpty
        alwaysOn
        label="outcome"
        source="outcome"
        choices={[
          { id: 'Ok', name: 'Ok' },
          { id: 'Ko', name: 'Ko' },
          { id: 'Unknown', name: '?' },
          { id: 'All', name: 'All' },
        ]}
      />
    </Filter>
  )
  return (
    <List
      filters={<LeadPropertyFilter />}
      title="Inspections"
      {...props}
      bulkActionButtons={false}
      filterDefaultValues={{ visitdate_flag: 'passed', active_flag: true, mine: true, outcome: 'Unknown' }}
      perPage={25}
    >
      <TabbedDatagrid />
    </List>
  )
}

export default ListLeadInspection
